import PropTypes from "prop-types";
import React, { useContext } from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import TargetPackageField from "./TargetPackageField";
import { OtaContext } from "../../context";

const styles = () => ({
  buttons: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginLeft: "12px",
  },
});

export const SendPackagesModal = (props) => {

  const { 
    modalOpen,
    handleModalClose,
    selectedVehicles,
    classes,
    type,
    t,
    defaultFirmware,
    defaultGeofence,
    geofencePackages,
    firmwarePackages,
    applyPackages,
  } = props;

  const {
    geofenceTargetPackage,
    setGeofenceTargetPackage,
    firmwareTargetPackage,
    setFirmwareTargetPackage,
  } = useContext(OtaContext);

  const closeModal = () => {
    handleModalClose();
  };

  const installHardware = async () => {
    closeModal();
    applyPackages();
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleModalClose}
      aria-labelledby="passive-hardware-modal"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
       <div>{type === "Firmware" ? t("Ota.SendFirmware") : t("Ota.SendGeofence")}</div>
       <Typography>{t("Ota.ThisChangeWill")} {selectedVehicles.length} {t("Ota.Vehicles")}</Typography>
      </DialogTitle>
      <DialogContent>
        <TargetPackageField
          packageType={type}
          value={type === "Firmware" ? firmwareTargetPackage ?? "" : geofenceTargetPackage ?? ""}
          onChange={(e) => {
            if (type === "Firmware") {
              setFirmwareTargetPackage(e.target.value);
            } else {
              setGeofenceTargetPackage(e.target.value);
            }
          }}
          geofencePackages={geofencePackages}
          firmwarePackages={firmwarePackages}
          defaultFirmware={defaultFirmware}
          defaultGeofence={defaultGeofence}
        />
        <div className={classes.buttons}>
          <Button
            variant="outlined"
            onClick={closeModal}
          >
            {t("Ota.Modals.Close")}
          </Button>
          <Button
            variant="outlined"
            onClick={installHardware}
            className={classes.button}
            disabled={type === "Firmware" ? !firmwareTargetPackage : !geofenceTargetPackage}
          >
            {t("Ota.Modals.Apply")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

SendPackagesModal.propTypes = {
  t: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  selectedVehicles: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  type: PropTypes.oneOf(["Firmware", "Geofence"]).isRequired,
  defaultFirmware: PropTypes.string,
  defaultGeofence: PropTypes.string,
  geofencePackages: PropTypes.array,
  firmwarePackages: PropTypes.array,
  applyPackages: PropTypes.func.isRequired,
};

SendPackagesModal.defaultProps = {
  defaultFirmware: "",
  defaultGeofence: "",
  geofencePackages: [],
  firmwarePackages: [],
};

export default withTranslation("common")(withStyles(styles)(SendPackagesModal));
